import { api } from '@marketplace-web/core-api/core-api-client-util'

import { GetEscrowOrderItemsResp } from '../types/escrow-order-item'
import { GetRefundResp } from '../types/refund'
import { ReuploadItemResp } from '../types/reupload-item'

export const getEscrowOrderItems = (orderId: number) =>
  api.get<GetEscrowOrderItemsResp>(`/escrow_orders/${orderId}/items`)

export const getRefund = (transactionId: number) =>
  api.get<GetRefundResp>(`/transactions/${transactionId}/refund`)

export const reuploadItem = (id: number) =>
  api.post<ReuploadItemResp>(`/transactions/${id}/reupload`)
